import React from "react";
import { useFormik, FieldArray, FormikProvider, ErrorMessage } from "formik";
import { Container, Button, Modal } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import Datetime from "react-datetime";

import Select from "react-select";
import currency from "currency.js";
import {
  convertMomentDate,
  convertToBaseCurrency,
  fetchActionsUtil,
} from "../../utils/helpers";
import { useStoreState } from "easy-peasy";
import DatePickerCustomInput from "../utils/DatePickerCustomInput";
import { Popover } from "react-tiny-popover";
import ModalLoader from "../utils/ModalLoader";
import ConfirmDialog from "../ConfirmDialogue";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { el } from "date-fns/locale";
import JobPOPicker from "../Jobs/JobPOPicker";

const StockAndIssueModal = ({ show, setShow, InvoiceNo, refetch }) => {
  const { backendUrl, token } = useAuth();
  const initialValues = {
    items: [
      {
        Item_Name: "",
        UnitCost: "",
        Quantity: "",
        StorageLocation: "",
        issueTo: "",
        receivingofficer: "",
        storageItemType: "consumable",
        storageIssuingType: "issueToJob",
        qty: 0,
        theSelectedJob: "",
        issueDate: new Date(),
      },
    ],
  };
  const generalSettings = useStoreState(state => state.generalSettings);

  const validate = values => {
    const errors = {};
    /*  if (!values.items || values.items.length === 0) {
      errors.items = "At least one item is required";
    } else { */
    const itemErrors = [];
    values.items.forEach((item, index) => {
      const itemError = {};

      // Do not validate a service item
      if (item?.Bar_Code?.includes("SERVICE")) {
        return;
      }

      if (!item.Item_Name) {
        itemError.Item_Name = "Item name is required";
      }
      if (!item.UnitCost) {
        // itemError.UnitCost = "Unit cost is required";
      } else if (isNaN(item.UnitCost) || parseFloat(item.UnitCost) < -1) {
        itemError.UnitCost = "Unit cost must be a valid positive number";
      }
      if (!item.Quantity) {
        itemError.Quantity = "Quantity is required";
      } else if (isNaN(item.Quantity) || parseInt(item.Quantity) < 1) {
        itemError.Quantity = "Quantity must be a valid positive integer";
      } else if (!item.issueTo) {
        itemError.issueTo = "Select Issue To";
      } else if (!item.receivingofficer) {
        itemError.receivingofficer = "Select Receiving Officer";
      } else if (!item.theSelectedJob) {
        itemError.theSelectedJob = "Select Job";
      }
      // else if (!item.StorageLocation && !item.Bar_Code.includes("SERVICE")) {
      //   itemError.StorageLocation = "Select a Storage Location";
      // }

      if (Object.keys(itemError).length > 0) {
        itemErrors[index] = itemError;
      }
    });
    if (itemErrors.length > 0) {
      errors.items = itemErrors;
    }

    // }
    return errors;
  };

  const updateItem = async payload => {
    payload.items = payload.items.map(item =>
      item.currency && item.currency !== generalSettings?.prevailingCurrency
        ? convertToBaseCurrency({
            data: item,
            conversionAmount: item.conversionAmount,
          })
        : item
    );

    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    formData.append("token", token);
    if (payload?.invoiceFile) {
      for (const file of payload.invoiceFile) {
        formData.append(`invoiceFile`, file);
      }
    }

    let response = await fetch(
      `${backendUrl}/api/invexcloud/save-to-warehouse`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const updateMutation = useMutation(payload => updateItem(payload), {
    onSuccess: ({ message, data }) => {
      if (refetch) {
        refetch();
      }
      toast.success(message);
      setShow(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: async values => {
      // console.log("Form values:", values);

      const groupedErrors = {};

      // Loop through all items and collect errors for each
      values.items.forEach((item, idx) => {
        // Do not validate a service item
        if (item?.Bar_Code?.includes("SERVICE")) {
          return;
        }

        const itemLabel = item.Item_Name || `#${idx + 1}`;
        const itemErrors = [];

        if (!item.issueTo) {
          itemErrors.push("Issue To is required");
        }
        if (!item.receivingofficer) {
          itemErrors.push("Receiving Officer is required");
        }
        if (!item.theSelectedJob) {
          itemErrors.push("Job/Contract is required");
        }

        // Only include the item if it has errors
        if (itemErrors.length > 0) {
          groupedErrors[itemLabel] = itemErrors;
        }
      });

      // If any items have errors, show them in a grouped toast
      if (Object.keys(groupedErrors).length > 0) {
        return toast.error(
          <div>
            {Object.entries(groupedErrors).map(([itemLabel, errs], i) => (
              <div key={i}>
                <strong>Item: {itemLabel}</strong>
                <ul style={{ marginTop: "4px", marginBottom: "8px" }}>
                  {errs.map((err, j) => (
                    <li key={j}>{err}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        );
      }

      if (
        await ConfirmDialog({
          title: "Issue Item",
          description: `Are you sure you want to issue these Items`,
        })
      ) {
        updateMutation.mutate({ ...values });
      }
    },
  });

  const fetchPurchaseHistory = async () => {
    //  alert("...");
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/invexcloud/purchase-request-grn-by-invoice/${InvoiceNo}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    let responseSetUp = await fetchActionsUtil(
      `${backendUrl}/api/warehouse/issuer-setup/all`,
      "GET"
    );

    const jobs = await fetchActionsUtil(`${backendUrl}/api/job`, "GET");

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.warehouses = data.warehouses?.map(el => ({
      ...el,
      value: el.W_ID,
      label: el.W_name,
    }));
    // DATA MUST GO SOMEHWERE, EMPTY MEANS SALES INVENTORY
    data.warehouses.unshift({ value: "", label: "Sales Inventory" });

    data.storageLocations = data.storageLocations.map(el => ({
      ...el,
      value: el.Storage_ID,
      label: el.storage_location,
    }));

    // Mine
    data.jobs = jobs?.data?.jobs?.map(el => ({
      value: el.jobNumber,
      label: el.title,
    }));

    data.inJobs = [{ label: "None", value: "" }, ...data?.jobs];

    const mergedRequesters = [
      ...(responseSetUp?.data?.staffs || []),
      ...responseSetUp?.data?.userRequesters,
    ];

    data.userRequesters = mergedRequesters?.map(el => ({
      value: el.name || el?.Name,
      label: el.name || el?.Name,
    }));

    data.locations = responseSetUp?.data?.Alllocation?.map(el => ({
      value: el.locationID,
      label: el.name,
    }));

    // set initials items
    formik.setFieldValue(
      "items",
      data.items.map(el => ({
        ...el,
        UnitCost: el?.UnitCost || 0,
        StorageLocation: "",
        issueTo: "",
        receivingofficer: "",
        storageItemType: "consumable",
        storageIssuingType: "issueToJob",
        qty: 0,
        theSelectedJob: el?.purRequisitionItems?.jobNumber || "",
        issueDate: new Date(),
      }))
    );

    return data;
  };

  const {
    data = {
      warehouses: [],
      items: [],
      inJobs: [],
      userRequesters: [],
      locations: [],
    },
    isLoading,
  } = useQuery(
    ["ITEMS_FOR_PURCHASE", InvoiceNo],
    () => fetchPurchaseHistory(),
    {
      keepPreviousData: true,
    }
  );

  return (
    <Container className="mt-4">
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        centered
        fullscreen
        backdrop="static"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Send to Stock And Issue - {InvoiceNo} - {show.vendorName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
              <FieldArray
                name="items"
                render={arrayHelpers => (
                  <>
                    <div className="table-responsive mb-3 product-table border">
                      <table className="table table-borderless table-striped align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Warehouse </th>
                            <th>Item Name</th>
                            <th>Storage Location</th>
                            <th>Quantity Received</th>
                            <th>Quantity to Issue</th>
                            <th>UOM</th>
                            <th>Contract/Job</th>
                            <th>Issue To</th>
                            <th>Receiving Officer</th>
                            <th>Issue type</th>
                            <th>Issue Date</th>
                            <th>Unit Cost</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formik.values.items.map((item, index) =>
                            item?.Bar_Code?.includes("SERVICE") ? (
                              <tr
                                key={index}
                                style={{ pointerEvents: "none", opacity: 0.5 }}
                              >
                                {/* G. A. New Update */}
                                {/* Service item should show in UI, for can not be modified or issued */}
                                <td>{index + 1}</td>
                                <td colSpan={13}>SERVICE: {item.Item_Name}</td>
                              </tr>
                            ) : (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <Select
                                      name={`items.${index}.Warehouse`}
                                      options={data.warehouses}
                                      value={
                                        data.warehouses.find(
                                          w => w.value === item.Warehouse
                                        ) || null
                                      }
                                      onChange={selected =>
                                        formik.setFieldValue(
                                          `items.${index}.Warehouse`,
                                          selected ? selected.value : ""
                                        )
                                      }
                                      onBlur={() =>
                                        formik.setFieldTouched(
                                          `items.${index}.Warehouse`,
                                          true
                                        )
                                      }
                                      placeholder=" "
                                      isClearable
                                      menuPosition="fixed"
                                    />
                                    {formik.errors.items?.[index]?.Warehouse &&
                                      formik.touched.items?.[index]
                                        ?.Warehouse && (
                                        <div className="invalid-feedback d-block">
                                          {formik.errors.items[index].Warehouse}
                                        </div>
                                      )}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <input
                                      name={`items.${index}.Item_Name`}
                                      type="text"
                                      className={`form-control ${
                                        formik.errors.items?.[index]
                                          ?.Item_Name &&
                                        formik.touched.items?.[index]?.Item_Name
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      placeholder="Enter item name"
                                      value={item.Item_Name}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      readOnly
                                    />
                                  </div>

                                  {formik.errors.items?.[index]?.Item_Name &&
                                    formik.touched.items?.[index]
                                      ?.Item_Name && (
                                      <div className="invalid-feedback">
                                        {formik.errors.items[index].Item_Name}
                                      </div>
                                    )}
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <Select
                                      classNamePrefix={`form-select`}
                                      options={data.storageLocations?.filter(
                                        storage =>
                                          storage?.W_name ===
                                          formik.values.items[index].Warehouse
                                      )}
                                      value={data.storageLocations?.find(
                                        el =>
                                          el.value ===
                                          formik.values.items[index]
                                            .StorageLocation
                                      )}
                                      onChange={select =>
                                        formik.setFieldValue(
                                          `items.${index}.StorageLocation`,
                                          select?.value
                                        )
                                      }
                                      placeholder="Storage Location"
                                      menuPosition="fixed"
                                    />
                                  </div>

                                  <ErrorMessage
                                    component="span"
                                    className="text-danger mb-2"
                                    name={`items.${index}.StorageLocation`}
                                  />
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <input
                                      name={`items.${index}.Quantity`}
                                      type="number"
                                      min="1"
                                      className={`form-control ${
                                        formik.errors.items?.[index]
                                          ?.Quantity &&
                                        formik.touched.items?.[index]?.Quantity
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      placeholder="1"
                                      value={item.Quantity}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      readOnly
                                    />
                                  </div>

                                  {formik.errors.items?.[index]?.Quantity &&
                                    formik.touched.items?.[index]?.Quantity && (
                                      <div className="invalid-feedback">
                                        {formik.errors.items[index].Quantity}
                                      </div>
                                    )}
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <input
                                      className="form-control"
                                      type="number"
                                      name="qty"
                                      value={formik.values.items[index].qty}
                                      onChange={e => {
                                        formik.setFieldValue(
                                          `items.${index}.qty`,
                                          e.target.value,
                                          true
                                        );
                                      }}
                                      onBlur={() =>
                                        formik.setFieldTouched(
                                          `items.${index}.qty`,
                                          true
                                        )
                                      }
                                      placeholder="0"
                                      max={formik.values.items[index].Quantity}
                                      min={1}
                                    />
                                  </div>

                                  <ErrorMessage
                                    component="span"
                                    className="text-danger mb-2"
                                    name={`items.${index}.qty`}
                                  />
                                </td>
                                <td>{item?.UOM || ""}</td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <Select
                                      classNamePrefix={"form-select"}
                                      isSearchable={true}
                                      menuPosition="fixed"
                                      value={data?.jobs?.find(
                                        el =>
                                          el.value ===
                                          formik.values.items[index]
                                            .theSelectedJob
                                      )}
                                      onChange={({ value }) => {
                                        formik.setFieldValue(
                                          `items.${index}.theSelectedJob`,
                                          value
                                        );
                                        // setCons(value);
                                      }}
                                      options={data?.jobs}
                                    />
                                  </div>

                                  <div className="my-1" />
                                  <JobPOPicker
                                    type="text"
                                    placeholder="Select PO Number"
                                    name="theSelectedJobPoNumber"
                                    value={
                                      formik.values.items[index]
                                        .theSelectedJobPoNumber
                                    }
                                    onChange={selected => {
                                      formik.setFieldValue(
                                        `items[${index}].theSelectedJobPoNumber`,
                                        selected?.value
                                      );
                                    }}
                                    jobNumber={
                                      formik.values.items[index]?.theSelectedJob
                                    }
                                  />
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <CreatableSelect
                                      isClearable
                                      menuPosition="fixed"
                                      onChange={select =>
                                        formik.setFieldValue(
                                          `items.${index}.issueTo`,
                                          select?.value
                                        )
                                      }
                                      options={data?.locations}
                                      value={data?.locations?.find(
                                        el =>
                                          el.value ===
                                          formik.values.items?.[index]?.issueTo
                                      )}
                                      onMenuClose={() => {
                                        formik.setFieldTouched(
                                          `items.${index}.issueTo`,
                                          true
                                        );
                                      }}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component="span"
                                    className="text-danger mb-2"
                                    name={`items.${index}.issueTo`}
                                  />
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <CreatableSelect
                                      isClearable
                                      menuPosition="fixed"
                                      onChange={selected => {
                                        formik.setFieldValue(
                                          `items.${index}.receivingofficer`,
                                          selected?.value
                                        );
                                      }}
                                      onMenuClose={() => {
                                        formik.setFieldTouched(
                                          `items.${index}.receivingofficer`,
                                          true
                                        );
                                      }}
                                      options={data.userRequesters}
                                      value={data.userRequesters?.find(
                                        el =>
                                          el.value ===
                                          formik.values.items[index]
                                            ?.receivingofficer
                                      )}
                                    />
                                  </div>
                                  <ErrorMessage
                                    component="span"
                                    className="text-danger mb-2"
                                    name={`items.${index}.receivingofficer`}
                                  />
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <select
                                      value={
                                        formik.values.items[index]
                                          .storageItemType
                                      }
                                      name="storageItemType"
                                      className="form-select "
                                      onChange={e => {
                                        formik.setFieldValue(
                                          `items.${index}.storageItemType`,
                                          e?.target?.value
                                        );
                                      }}
                                    >
                                      <option value="">Choose Item Type</option>
                                      <option value="consumable">
                                        For consumption
                                      </option>
                                      <option value="returnAfterUse">
                                        Return after use
                                      </option>
                                    </select>
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <Popover
                                      positions={["bottom", "left"]}
                                      reposition={false}
                                      isOpen={
                                        formik.values.items[index]
                                          .datePopoverOpened
                                      }
                                      onClickOutside={() => {}}
                                      align="end"
                                      padding={10}
                                      content={() => (
                                        <Datetime
                                          dateFormat="MM DD, YYYY"
                                          className="date-picker-2"
                                          timeFormat={false}
                                          closeOnSelect={true}
                                          closeOnClickOutside={true}
                                          name="issueDate"
                                          inputProps={{
                                            className: `date-input form-control ${
                                              formik.values.items[index]
                                                .issueDate &&
                                              !!formik.values.items[index]
                                                .issueDate
                                                ? "is-invalid"
                                                : ""
                                            }`,
                                            placeholder: "Select date",
                                            readOnly: true,
                                          }}
                                          input={false}
                                          value={
                                            formik.values.items[index].issueDate
                                          }
                                          onChange={date => {
                                            formik.setFieldValue(
                                              `items[${index}].issueDate`,
                                              date,
                                              true
                                            );
                                            formik.setFieldValue(
                                              `items[${index}].datePopoverOpened`,
                                              false
                                            );
                                          }}
                                          onBlur={() =>
                                            formik.setFieldTouched(
                                              "issueDate",
                                              true
                                            )
                                          }
                                        />
                                      )}
                                    >
                                      <DatePickerCustomInput
                                        onClick={() =>
                                          formik.setFieldValue(
                                            `items[${index}].datePopoverOpened`,
                                            !formik.values.items[index]
                                              .datePopoverOpened
                                          )
                                        }
                                        value={convertMomentDate(
                                          formik.values.items[index].issueDate
                                        )}
                                      />
                                    </Popover>
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    <CurrencyCustomInput
                                      name={`items.${index}.UnitCost`}
                                      value={item.UnitCost}
                                      onValueChange={(value, name) =>
                                        formik.setFieldValue(name, value)
                                      }
                                      placeholder="0.00"
                                      decimalsLimit={2}
                                    />
                                  </div>

                                  {formik.errors.items?.[index]?.UnitCost &&
                                    formik.touched.items?.[index]?.UnitCost && (
                                      <div className="invalid-feedback">
                                        {formik.errors.items[index].UnitCost}
                                      </div>
                                    )}
                                </td>
                                <td>
                                  <div style={{ width: "200px" }}>
                                    {currency(
                                      item.UnitCost && item.Quantity
                                        ? (
                                            parseFloat(item.UnitCost || 0) *
                                            parseInt(item.Quantity || 0)
                                          ).toFixed(2)
                                        : "0.00",
                                      {
                                        symbol: "",
                                      }
                                    ).format()}
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="12" className="text-end">
                              <strong>Total:</strong>
                            </td>
                            <td colSpan="2">
                              <strong>
                                {currency(
                                  formik.values.items
                                    .reduce((total, item) => {
                                      const itemTotal =
                                        parseFloat(item.UnitCost || 0) *
                                        parseInt(item.Quantity || 0);
                                      return total + itemTotal;
                                    }, 0)
                                    .toFixed(2),
                                  {
                                    symbol: "",
                                  }
                                ).format()}
                              </strong>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </>
                )}
              />
              <div className="d-flex justify-content-end gap-2">
                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  className="px-4"
                  disabled={updateMutation.isLoading}
                >
                  {updateMutation.isLoading ? "Submitting..." : "Post"}
                </Button>
              </div>
            </form>
          </FormikProvider>
        </Modal.Body>
      </Modal>
      <ModalLoader show={updateMutation.isLoading || isLoading} />
    </Container>
  );
};

export default StockAndIssueModal;
